import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token (robust fallback alongside httpOnly cookies)
export function setToken(token) {
  if (token) {
    localStorage.setItem("cr_token", token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("cr_token");
    delete api.defaults.headers.common.Authorization;
  }
}
const saved = typeof localStorage !== "undefined" ? localStorage.getItem("cr_token") : null;
if (saved) api.defaults.headers.common.Authorization = `Bearer ${saved}`;

export const getToken = () => (typeof localStorage !== "undefined" ? localStorage.getItem("cr_token") : null);

// Build a URL for a stored file; append token for private files served through the API
export const fileUrl = (url, withAuth = false) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  const full = `${BACKEND}${url}`;
  if (withAuth) {
    const t = getToken();
    return t ? `${full}?token=${encodeURIComponent(t)}` : full;
  }
  return full;
};

// Owner secondary-password gate token (sessionStorage)
export const gate = {
  get: () => (typeof sessionStorage !== "undefined" ? sessionStorage.getItem("cr_gate") : null),
  set: (t) => { if (t) sessionStorage.setItem("cr_gate", t); else sessionStorage.removeItem("cr_gate"); },
};
export const gateHeaders = () => { const t = gate.get(); return t ? { headers: { "X-Owner-Gate": t } } : {}; };

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
